export const environment = {
  base_url: 'https://api-uat.osquare.solutions',
  web_url: 'https://uat.osquare.solutions',
  microUrls: [
    'https://easyform-uat.osquare.solutions',
    'https://inventory-uat.osquare.solutions',
    'https://accounting-uat.osquare.solutions',
    'https://leadkonnect-uat.osquare.solutions',
    'https://payroll-uat.osquare.solutions',
    'https://auth-uat.osquare.solutions',
  ],
  storage_key: '2a554677-086a-4f1b-a83b-c82433d1288f',
  cookieDomain: 'osquare.solutions',
  version: '1.0.0',
  production: true,
};
